import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollArea } from "@mantine/core";
import { SourceLayerConfigHeader } from "./SourceLayerConfigHeader.js";
import { LayerDataSource } from "../Layers/LayerDataSource.js";
import { SecondaryPanel } from "../../components/SidePanel.js";
export const SourceLayerConfigData = ({ sourceLayerId, layer, sourceInfo, }) => {
    return (_jsxs(SecondaryPanel, { children: [_jsx(SourceLayerConfigHeader, { sourceLayerId: sourceLayerId, layer: layer }), _jsx(ScrollArea, { flex: "1", mih: 0, children: layer && (_jsx(LayerDataSource, { layer: layer, sourceLayerId: sourceLayerId, sourceInfo: sourceInfo })) })] }));
};
